import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize'
})
export class FilesizePipe implements PipeTransform {

  transform(size: number, roundTo: number = 2, unit: string = 'MB'): number {
    let returnSize: number;
    switch(unit) {
      case 'MB':
        returnSize = roundTo ? +((size / (1024*1024)).toFixed(roundTo)) : (size / (1024*1024));
        break;
    }
    return returnSize;
  }

}
